import { IUser } from "interfaces/user.interface";
import { createContext, MutableRefObject, useContext } from "react";

type AuthContextType = {
  googleSignIn: () => Promise<any>;
  facebookSignIn: () => Promise<any>;
  appleSignIn: () => Promise<any>;
  user: IUser;
  setUserData: (data: IUser) => void;
  isAuthenticated: boolean;
  logout: () => void;
  refetchUser: () => void;
  phoneNumberSignIn: (phone: string) => Promise<any>;
  openAuthModal: () => void;
  closeAuthModal: () => void;
  authModalOpen: boolean;
  withAuth: (fn: Function) => Function;
  isConfirmNeedForCloseModal: MutableRefObject<boolean>;
  walletHistoryOpen: boolean;
  openWalletHistory: () => void;
  closeWalletHistory: () => void;
};

export const AuthContext = createContext<AuthContextType>(
  {} as AuthContextType,
);

export const useAuth = () => useContext(AuthContext);
